import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
	*, *::after, *::before {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
		font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
	}

	a {
		text-decoration: none;
		color: inherit;
		
	}

	input:disabled {
		cursor: not-allowed;
		font-style: italic;
		background-color: #e8e8e8;
		color: darkgrey;
	}

	.disabled {
		cursor: not-allowed;
		font-style: italic;
		color: darkgrey;
	}

	input, select {
		padding: 0.4rem;
		font-size: 14px;
	}

	select:focus {
		outline: 1px solid;
	}

`;

export const MainContainer = styled.div`
	max-width: 90vw;
	margin: 0 auto;
	height: calc(100vh - 6rem);
`;
